export default "__VITE_ASSET__Clo69uRs__"